import React from 'react';
import { push } from 'connected-react-router';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const FormsTabActions = ({ permissions, dispatch, openDeleteFormModal, openEditFormTypeModal, openReassignWhsDocumentModal }) => {
  const clickedView = (row) => {
    if (!row || !row.original) {
      return;
    }
    const { formType, accountId, id } = row.original;

    if (!formType || formType === 'N/A') {
      return;
    }

    let formUrl = `/forms/${ String(formType).toLowerCase() }/${ id }`;

    if (row.original.boName === 'Unassigned') {
      formUrl = `${ formUrl }/pdf`;
    }

    if (accountId && accountId > 0) {
      formUrl = `${ formUrl }?account=${ accountId }`;
    }

    dispatch(push(formUrl));
  };

  return {
    id: 'action-column',
    Header: <span className="expand-header-offset">Actions</span>,
    Cell: ({ row }) => (
      <div className="form-action-btn-group">
        { AccessControl.hasPermission(
          permissions,
          [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate]
        )
        && <button
          type="button"
          className="btn btn-sm"
          onClick={ () => clickedView(row) }
          title={ row.original.boName === 'Unassigned' ? 'View PDF' : 'View Form' }
          disabled={ row.original.isForm === false }
          id={ `formViewBtn_${ row.original.id }` }
        >
          <span className="icon icon-apps" />
        </button> }
        { (
          (
            row.original.isOnlineForm && AccessControl.hasPermission(
              permissions,
              [ActivityPerms.electronicValidate]
            ) // Validate includes edit permission on the UI.
          )
          || (
            !row.original.isOnlineForm && AccessControl.hasPermission(
              permissions,
              [ActivityPerms.scannedEdit]
            )
          )
        )
        && row.original.boName !== 'Unassigned'
        && <button
          className="btn btn-sm"
          type="button"
          title="Edit form type"
          onClick={ () => openEditFormTypeModal(row.original) }
          disabled={
                row.original.isForm === false
                || !row.original.otherFormTypesInFamily
                || Object.keys(row.original.otherFormTypesInFamily).length === 0
              }
          id={ `editFormTypeBtn_${ row.original.id }` }
        >
          <span className="icon icon-edit" />
        </button> }
        { (
          (
            row.original.isOnlineForm && AccessControl.hasPermission(
              permissions,
              [ActivityPerms.electronicValidate]
            ) // Validate includes edit permission on the UI.
          )
          || (
            !row.original.isOnlineForm && AccessControl.hasPermission(
              permissions,
              [ActivityPerms.scannedEdit]
            )
          )
        )
        && <button
          className="btn btn-sm"
          type="button"
          title="Reassign Form"
          onClick={ () => openReassignWhsDocumentModal(row.original) }
          disabled={ row.original.isForm === false }
          id={ `reassignFormBtn_${ row.original.id }` }
        >
          <span className="icon icon icon-people" />
        </button> }
        {
          (
            (
              (
                row.original.isOnlineForm
                      && (
                        (AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteCompleteForms]) && row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
                      || (AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteInReviewForms]) && !row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
                      )
              )
                    || (
                      !row.original.isOnlineForm
                      && (
                        (AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteCompleteForms]) && row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
                        || (AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteInReviewForms]) && !row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
                      )
                      && row.original.formType
                      && row.original.formType.toLowerCase() !== 'unknown'
                    )
            )
          )
        && <button
          className="btn btn-sm btn-danger"
          type="button"
          title="Delete form"
          disabled={ row.original.isForm === false || row.original.hasReviewBegan }
          onClick={ () => openDeleteFormModal(row.original) }
          id={ `deleteFormBtn_${ row.original.id }` }
        >
          <span className="icon icon-delete" />
        </button>
        }
      </div>
    ),
    className: 'col-10p',
  };
};
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default FormsTabActions;
